import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemServicesRoute: InvariantJiraRoute = {
	name: 'global-settings-system-services',
	path: '/secure/admin/ViewServices!default.jspa',
};
